import type { DeliveryMethodType, Product } from '@libs/common-types';

import type { PurchaseOption } from '../../product-details';

export function isMethodAvailableForPurchaseOption(
    product: Pick<Product, 'deliveryMethods'>,
    method: DeliveryMethodType,
    purchaseOption: PurchaseOption
): boolean {
    const purchaseOptionKey = purchaseOption === 'autoship' ? 'autoship' : 'oneTime';

    return Boolean(product.deliveryMethods[method].availablePurchaseOptions?.[purchaseOptionKey]);
}
